export const cutString = (text, startNumber, endNumber, isHTML) => {
  if (isHTML) {
    return text.replace(/<[^>]*>?/gm, '').slice(startNumber, endNumber);
  }
  return text.slice(startNumber, endNumber);
};